<template>
  <TemplateView v-if="visibleTemplateView" :template="templateContent" :props="Object.assign(formData, form)" />
</template>

<script>
/**
 * @param TemplateViewer
 *
 * @description A listák lenyitásakor megjelenő template komponens
 */
import TemplateView from './TemplateView'
import { isEmpty, get, set, startsWith } from 'lodash'
import EventBus from '../../utils/event-bus'
import cssLoader from '../../utils/mixin-css-loader'
import md5 from 'crypto-js/md5'
import { replaceRouterLinks } from '../../utils/spa-common'

export default {
  name: 'TemplateViewer',
  mixins: [cssLoader],
  components: {
    TemplateView,
  },
  props: {
    form: {
      type: Object,
    },
    template: {
      type: Object,
      required: true,
      validator(value) {
        return 'id' in value
      },
    },
  },
  data: () => ({
    formData: {},
    templateContent: null,
    jsContent: null,
  }),
  computed: {
    pk() {
      return startsWith(this.form.pk, ':')
          ? get(CORE.params, this.form.pk.slice(1), null)
          : this.form.pk;
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: false,
      handler: 'fetchFormData',
    },
    template: {
      deep: true,
      immediate: false,
      handler: 'fetchTemplateContent',
    },
  },
  mounted() {
    this.init()
    EventBus.$on('refresh-panel', this.refreshTemplateView)
  },
  beforeDestroy() {
    EventBus.$off('refresh-panel', this.refreshTemplateView)
  },
  methods: {
    async init() {
      await this.fetchFormData()
      await this.fetchTemplateContent()
    },
    isEmpty,
    setScript(content = '') {
      const jsContentHash = md5(content).toString()
      if (get(window.CORE, ['alreadyLoadedInHeader', 'scripts', jsContentHash])) return
      let script = document.createElement('script')
      script.setAttribute('type', 'text/javascript')
      script.appendChild(document.createTextNode(content))
      document.head.appendChild(script)
      set(window.CORE, ['alreadyLoadedInHeader', 'scripts', jsContentHash], true)
    },
    async fetchFormData() {
      let formData = {}
      if (this.form && this.form.id) {
        formData = await this.$client.apis['Dynform']['Dynform_getDataTemplate']({
          idForm: this.form.id,
          idMaintable: this.pk,
        })
      }
      this.formData = formData.obj ? formData.obj : formData
    },
    async fetchTemplateContent() {
      if (!this.template.id) return
      const { obj } = await this.$client.apis['Layout']['Layout_findOne']({
        filter: JSON.stringify({
          where: {
            idLayout: this.template.id,
          },
          fields: {
            htmlContentVue: true,
            jsContent: true,
            cssContent: true,
          },
        }),
      })
      const htmlContentVue = get(obj, 'htmlContentVue', ) || '<div></div>'
      const html = replaceRouterLinks(htmlContentVue)
      const jsContent = get(obj, 'jsContent')
      if (jsContent) this.setScript(jsContent)
      this.templateContent = html.replace(/\n|\r/gm, '')
      const cssContent = get(obj, 'cssContent')
      if (cssContent) this.addStyle(cssContent)
    },
    visibleTemplateView() {
      if (!this.form) return true
      if (!this.form.id || !this.form.pk) return true

      return !!(this.templateContent && !isEmpty(this.formData))
    },
    refreshTemplateView() {
      this.$forceUpdate()
    }
  },
}
</script>
